import Vue from "vue";
import Vuex from "vuex";
import * as track from '@/utilities/tracking';
import assumptions from '@/calculators/assumptions';

const defaultState = () => ({
  step: 0,
  product: null,
  calculator: null,
  lifeInsurance: 0,
  debts: 50000,
  customDebts: null,
  expenses: 1000,
  customExpenses: null,
  income: 50000,
  customIncome: null,
  incomeOther: 0,
  customIncomeOther: null,
  time: 2,
  debtRepayment: 2000,
  customDebtRepayment: null,
  customTime: null,
  children: false,
  school: null,
  schoolFees: null,
  childrenNumber: 1,
  customChildrenNumber: null,
  childrenAge: [],
  previous: null,
  ...assumptions
});

Vue.use(Vuex);

export default new Vuex.Store({
  state: defaultState(),
  mutations: {
    update(state, val) {
      switch (val.name) {
        case "product":
          state.product = val.value;
          break;
        case "calculator":
          state.calculator = val.value;
          break;
        case "debts":
          state.debts = val.value;
          break;
        case "customDebts":
          state.customDebts = val.value;
          break;
        case "expenses":
          state.expenses = val.value;
          break;
        case "customExpenses":
          state.customExpenses = val.value;
          break;
        case "income":
          state.income = val.value;
          break;
        case "customIncome":
          state.customIncome = val.value;
          break;
        case "incomeOther":
          state.incomeOther = val.value;
          break;
        case "customIncomeOther":
          state.customIncomeOther = val.value;
          break;
        case "time":
          state.time = val.value;
          break;
        case "customTime":
          state.customTime = val.value;
          break;
        case "children":
          state.children = val.value;
          break;
        case "school":
          state.school = val.value;
          break;
        case "schoolFees":
          state.schoolFees = val.value;
          break;
        case "childrenNumber":
          state.childrenNumber = val.value;
          break;
        case "customChildrenNumber":
          state.customChildrenNumber = val.value;
          break;
        case "childrenAge":
          state.childrenAge = val.value;
          break;
        case "debtRepayment":
          state.debtRepayment = val.value;
          break;
        case "customDebtRepayment":
          state.customDebtRepayment = val.value;
          break;
        case "step":
          state.step = val.value;
          break;
        case "previous":
          state.previous = val.value;
          break;
        case "funeralCost":
          state.funeralCost = val.value;
          break;
        case "yearsStdLiving":
          state.yearsStdLiving = val.value;
          break;
        case "childcareWeekly":
          state.childcareWeekly = val.value;
          break;
        case "schoolAnnualPrivate":
          state.schoolAnnualPrivate = val.value;
          break;
        case "schoolAnnualGovernment":
          state.schoolAnnualGovernment = val.value;
          break;
      }
    },

    reset(state) {
      const resetValues = {
        ...defaultState(),
        calculator: state.calculator,
        product: state.product,
        step: 1
      };

      Object.keys(state).forEach((key) => {
        state[key] = resetValues[key]
      })
    } 
    
  },
  actions: {
    update({ commit }, props) {
      commit('update', props)
    }
  },
  getters: {
    getAssumptions(state) {
      return {
        yearsStdLiving: state.yearsStdLiving,
        funeralCost: state.funeralCost,
        childcareWeekly: state.childcareWeekly,
        schoolAnnualPrivate: state.schoolAnnualPrivate,
        schoolAnnualGovernment: state.schoolAnnualGovernment
      }
    }
  }
});
